import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import { withPrefix } from 'gatsby'

// ArComponents
import ArHeroTwoImagesWrapper from './ArHeroTwoImagesWrapper/ArHeroTwoImagesWrapper'
import ArHeroHeadingWrapper from './ArHeroHeadingWrapper/ArHeroHeadingWrapper'
import ArHeroImageWrapper from './ArHeroImageWrapper/ArHeroImageWrapper'
import ArHeroContainer from './ArHeroContainer/ArHeroContainer'
import ArFormContact from 'src/components/forms/ArFormContact'

// Variants
import variantUsecasesUnderwriters from './variants/variantUsecasesUnderwriters'
import variantProductDistribute from './variants/variantProductDistribute'
import variantUsecasesBroker from './variants/variantUsecasesBroker'
import variantCompanyCareers from './variants/variantCompanyCareers'
import variantProductManage from './variants/variantProductManage'
import variantBetaCommunity from './variants/variantBetaCommunity'
import variantCompanyAbout from './variants/variantCompanyAbout'
import variantProductBuild from './variants/variantProductBuild'
import variantProductPrice from './variants/variantProductPrice'
import variantUsecasesMga from './variants/variantUsecasesMga'
import variantHomepage from './variants/variantHomepage'
import variantSecurity from './variants/variantSecurity'
import variantPricing from './variants/variantPricing'
import variantPrivacy from './variants/variantPrivacy'
import variantContact from './variants/variantContact'

const StyledWrapper = styled.section`
  background-color: ${ ({ theme, backgroundImage }) => backgroundImage ? 'transparent' : theme.colors.black };
  color: ${ ({ theme }) => theme.colors.white };
  position: relative;
  z-index: 10;
  ${ ({ mobileWrapperStyles }) => mobileWrapperStyles }
  ${ media.tablet`${ ({ tabletWrapperStyles }) => tabletWrapperStyles }` }
  ${ media.desktop`${ ({ desktopWrapperStyles }) => desktopWrapperStyles }` }
  :after {

  }
`

const StyledTriangle = styled.img`
  bottom: -1px;
  height: 35px;
  left: 0;
  pointer-events: none;
  position: absolute;
  width: 100%;
  z-index: 50;
  ${ media.tablet`
    height: 65px;
  ` }
  ${ media.desktop`
    height: 130px;
  ` }
  ${ ({ clipReversed }) => clipReversed && css`
    transform: scaleX(-1);
  ` }
`

class ArHeroHeader extends React.Component {
  static propTypes = {
    image: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    cta: PropTypes.object,
    scImageLeft: PropTypes.bool,
    scGap: PropTypes.number,
    variant: PropTypes.oneOf([
      'homepage',
      'beta',
      'product-build',
      'product-distribute',
      'product-price',
      'product-manage',
      'usecases-underwriters',
      'usecases-broker',
      'usecases-mga',
      'company-about',
      'company-careers',
      'company-privacy',
      'company-security',
      'contact',
      'pricing',
    ]),
  }

  get heroHeaderWrappersProps () {
    const { image, images, title, description, imageDesktop, video, videoMobile, videoTablet, videoDesktop, cta } = this.props
    const headingWrapperProps = {
      cta,
      title,
      description,
    }
    const imageWrapperProps = {
      image,
      images,
      video,
      videoMobile,
      videoTablet,
      videoDesktop,
    }

    switch (this.props.variant) {
    case 'homepage':
      return variantHomepage({
        headingWrapperProps,
        imageWrapperProps,
        imageDesktop,
      })
    case 'beta':
      return variantBetaCommunity({
        headingWrapperProps,
        imageWrapperProps,
        imageDesktop,
      })
    case 'product-build':
      return variantProductBuild({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'product-distribute':
      return variantProductDistribute({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'product-price':
      return variantProductPrice({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'product-manage':
      return variantProductManage({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'usecases-underwriters':
      return variantUsecasesUnderwriters({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'usecases-broker':
      return variantUsecasesBroker({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'usecases-mga':
      return variantUsecasesMga({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'company-about':
      return variantCompanyAbout({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'company-careers':
      return variantCompanyCareers({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'company-privacy':
      return variantPrivacy({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'company-security':
      return variantSecurity({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'contact':
      return variantContact({
        headingWrapperProps,
        imageWrapperProps,
      })
    case 'pricing':
      return variantPricing({
        headingWrapperProps,
        imageWrapperProps,
      })

    default:
      return (<div></div>)
    }
  }

  render () {
    const { form, animationComponent } = this.props
    const { wrapperProps, containerProps, headingWrapperProps, imageWrapperProps, triangleProps, formProps } = this.heroHeaderWrappersProps
    return (
      <StyledWrapper {...wrapperProps}>
        <ArHeroContainer {...containerProps}>
          <ArHeroHeadingWrapper {...headingWrapperProps}/>
          {form
            ? <ArFormContact {...formProps} form={form} />
            : animationComponent || (imageWrapperProps.images
              ? <ArHeroTwoImagesWrapper {...imageWrapperProps}/>
              : <ArHeroImageWrapper {...imageWrapperProps}/>)
          }
          {!triangleProps.clipDisabled && <StyledTriangle {...triangleProps} src={withPrefix('img/ArHeroHeaderRect.svg')} />}
        </ArHeroContainer>
      </StyledWrapper>
    )
  }
}

export default ArHeroHeader
